// 实现与 {{ xxx | handle }} 一样的功能
function handleize(str) {
  // 确保转换为字符串
  let result = str.toString()
    .toLowerCase()        // 转换为小写字母
    .replace(/\s+/g, '-') // 替换空格为连字符
    .replace(/[^\w\-]+/g, '') // 移除非字母数字字符
    .replace(/--+/g, '-')   // 将多个连字符合并为一个
    .replace(/^-+/, '')     // 移除开头的连字符
    .replace(/-+$/, '');    // 移除结尾的连字符

  // 如果结果是以数字开头，则在前面加上下划线
  if (/^\d/.test(result)) {
    result = '_' + result;
  }

  return result;
}

// 滚动到指定元素位置
const scrollToTarget = (target, smoothScroll) => {
  let mql = window.matchMedia('(max-width: 767px)');
  let isMobile = mql.matches;
  let fixedHeaderHeight = 0;
  let realTarget = target;
  const parentSection = target.closest('.shopify-section');
  if (parentSection.classList.contains('newsletter-section')) {
    realTarget = parentSection;
  }
  let distance = window.scrollY + realTarget.getBoundingClientRect().top;
  const fixHeaderNavigation = document.querySelector('#StickyHeaderWrap #SiteHeader.site-header--stuck');
  const ul = document.querySelector('#pProductOverviewMenu ul');
  const catalog = ul ? getComputedStyle(ul).height : '0px';
  if (fixHeaderNavigation) {
    const fixHeaderNavigationHeight = getComputedStyle(fixHeaderNavigation).height;
    fixedHeaderHeight = Number(fixHeaderNavigationHeight.replace('px', '')) + Number(catalog.replace('px', ''));
  } else {
    const headerNavigation = document.querySelector('#SiteHeader');
    const trustBar = document.querySelector('#SiteHeader .trust-bar');
    let headerNavigationHeight = getComputedStyle(headerNavigation).height
    if (trustBar) {
      headerNavigationHeight = Number(headerNavigationHeight.replace('px', '')) + (isMobile ? 38 : 40);
    }
    fixedHeaderHeight = headerNavigationHeight + Number(catalog.replace('px', ''));
    distance -= isMobile ? 40 : 69;
  }

  savedFixedHeaderHeight = fixedHeaderHeight;

  const headerCountDown = document.querySelector('.shopify-section-group-header-group.countdown-section');
  if (headerCountDown && headerCountDown.style.display === 'block' && !headerCountDown.classList.contains('hide')) {
    let headerCountDownHeight = fixHeaderNavigation ? 0 : headerCountDown.clientHeight;
    if (isMobile) {
      headerCountDownHeight = 0;
    }
    
    if (smoothScroll) {
      window.scrollTo({
        top: distance - fixedHeaderHeight + 1 - headerCountDownHeight,
        left: 0,
        behavior: 'smooth'
      })
    } else {
      window.scrollTo(0, distance - fixedHeaderHeight + 1 - headerCountDownHeight);
    }
  } else {
    if (smoothScroll) {
      window.scrollTo({
        top: distance - fixedHeaderHeight + 1,
        left: 0,
        behavior: 'smooth'
      })
    } else {
      window.scrollTo(0, distance - fixedHeaderHeight + 1);
    }
  }
}

// 获取 url 里 ? 后的指定 key 的值
function getURLParameter(key) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + key + "=([^&;]+?)(&|#|;|$)", "i").exec(
        location.search
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

// 打开页面，然后滚动到指定 ID
function getElement(id) {
  const target = document.getElementById(id);
  if (target) {
    scrollToTarget(target);
  } else {
    requestAnimationFrame(() => getElement(id)); // 若元素未找到，继续尝试
  }
}
const openAndScroll = () => {
  const targetId = getURLParameter('id');
  if (targetId) {
    getElement(targetId);
  }
};
openAndScroll();

;(function() {
    var throttle = function(type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function() {
            if (running) { return; }
            if (timeout) clearTimeout(timeout);
            running = true;
            var timeout = setTimeout(() => {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            },500)
        };
        obj.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle("resize", "optimizedResize");
})();

function syncCartDrawer(val) {
  if (val.sections && val.sections['mini-cart']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(val.sections['mini-cart'], 'text/html');
    
      const cartDrawer = document.querySelector('#CartDrawer');
      cartDrawer.innerHTML = doc.querySelector("#CartDrawer").innerHTML;
  }
}

function addProduct(item) {
  const productId = item.dataset.productId;
  const formId = item.dataset.formId;
  const recommendationForm = document.querySelector('.recommendation-form');
  const idInput = document.querySelector('.recommendation-form input[name="id"]');
  const addToCartBtn = document.querySelector('.recommendation-form .add-to-cart');
  recommendationForm.id = formId;
  idInput.value = productId;
  addToCartBtn.click();
  item.classList.add('btn--loading');
}

document.addEventListener('productCart:updated', function(event) {
  const cart = event.detail.cart; // Get the updated content of the cart
  const items = cart.items;
  const itemIDArray = [];
  
  if (items && items.length > 0) {
    items.forEach((item) => {
      itemIDArray.push(item.variant_id);
    })
  }
  sessionStorage.itemIDArray = JSON.stringify(itemIDArray);
});


function setFormNote(dataObject) {
  hideBtns();
  const productFormList = document.querySelectorAll('form[action="/cart/add"]');
  if (productFormList.length) {
    let countryCode = 'US';
    const origin = location.origin;
    if (origin.includes('ca.')) {
      countryCode = 'CA';
    } else if (origin.includes('au.')) {
      countryCode = 'AU';
    } else if (origin.includes('jp.')) {
      countryCode = 'JP';
    } else if (origin.includes('de.')) {
      countryCode = 'DE';
    }
    productFormList.forEach((item) => {
      const channelNote = document.createElement('input');
      const channelUserIdNote = document.createElement('input');
      const channelCountryCodeNote = document.createElement('input');
      channelNote.setAttribute('type', 'text');
      channelUserIdNote.setAttribute('type', 'text');
      channelCountryCodeNote.setAttribute('type', 'text');
      
      channelNote.setAttribute('name', 'attributes[channel]');
      channelUserIdNote.setAttribute('name', 'attributes[channelUserId]');
      channelCountryCodeNote.setAttribute('name', 'attributes[channelCountryCode]');
      
      channelNote.classList.add('hide');
      channelUserIdNote.classList.add('hide');
      channelCountryCodeNote.classList.add('hide');
      
      if (dataObject) {
        channelNote.value = dataObject.channel;
        channelUserIdNote.value = dataObject.userId;
        channelCountryCodeNote.value = countryCode;
        
        item.appendChild(channelNote);
        item.appendChild(channelUserIdNote);
        item.appendChild(channelCountryCodeNote);
      }
    })
  }
}


// 接收来自 APP 的数据
function receiveDataFromApp(data) {
  setFormNote(data);
}

// 隐藏无法添加购物车备注的插件的加购按钮和直接跳转结账页的按钮
function hideBtns() {
  const style  = document.createElement('style');
  style.type = 'text/css';  
  const cssContent = `  
    [data-shopify="payment-button"],
    .additional-checkout-buttons,
    .cbb-frequently-bought-container,
    #bundle-sticky_add_to_cart.Vtl-StickyAddToCart,
    #sticky_add_to_cart_root,
    #bundle-sticky_add_to_cart {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
      overflow: hidden !important;
    }
    .drawer .cart__checkout {
      width: 100% !important;
    }
  `;
  style.appendChild(document.createTextNode(cssContent));
  document.head.appendChild(style); 
}

document.addEventListener('DOMContentLoaded', () => {
  try {
    // iOS 平台，先发送一个空信息给 APP，然后 APP 会调用约定好的 receiveDataFromApp 函数，传入data然后绑定到 form
    window.webkit.messageHandlers.getDataFromApp.postMessage(null);
  } catch (error) {
    if (typeof AndroidApp !== 'undefined' && AndroidApp) {
     // Android 平台，直接接收到数据然后绑定到 form
    const jsonString = AndroidApp.getDataFromApp();
    const dataObject = JSON.parse(jsonString); // 解析 JSON 字符串
    setFormNote(dataObject);
   }
  }
})